import { useSettings } from '../App/CartContext';

const FooterButtons = ({
  pscfw_btn_row = 'one_row',
  pscfw_button_position = [],
}) => {
  const { settings } = useSettings();

  const BUTTON_CONFIG = {
    cart: {
      label: settings?.cart_btn_text,
      onClick: () => {
        window.location.href = settings?.cart_btn_url;
      },
    },
    checkout: {
      label: settings?.checkout_btn_text,
      onClick: () => {
        window.location.href = settings?.checkout_btn_url;
      },
    },
    keepshopping: {
      label: settings?.shopping_btn_text,
      onClick: () => {
        if (settings?.continue_shopping_btn_url === '#') {
          window.location.reload();
        } else {
          window.location.href = settings?.continue_shopping_btn_url;
        }
      },
    },
  };

  const buttons = pscfw_button_position
    .map((key) => BUTTON_CONFIG[key])
    .filter(Boolean);

  if (!buttons.length) return null;

  const renderButtons = () => {
    /* ONE ROW */
    if (pscfw_btn_row === 'one_row') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {buttons.map((btn, i) => (
            <button
              type="button"
              key={i}
              onClick={btn.onClick}
              style={{ flex: 1 }}
            >
              {btn.label}
            </button>
          ))}
        </div>
      );
    }

    /* TWO + ONE */
    if (pscfw_btn_row === 'two_one_row') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'flex', gap: 10 }}>
            {buttons.slice(0, 2).map((btn, i) => (
              <button
                type="button"
                key={i}
                onClick={btn.onClick}
                style={{ flex: 1 }}
              >
                {btn.label}
              </button>
            ))}
          </div>

          {buttons[2] && (
            <button
              type="button"
              onClick={buttons[2].onClick}
              style={{ width: '100%' }}
            >
              {buttons[2].label}
            </button>
          )}
        </div>
      );
    }

    /* ONE + TWO */
    if (pscfw_btn_row === 'one_two_row') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {buttons[0] && (
            <button
              type="button"
              onClick={buttons[0].onClick}
              style={{ width: '100%' }}
            >
              {buttons[0].label}
            </button>
          )}

          <div style={{ display: 'flex', gap: 10 }}>
            {buttons.slice(1, 3).map((btn, i) => (
              <button
                type="button"
                key={i}
                onClick={btn.onClick}
                style={{ flex: 1 }}
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div
      className="footer-section"
      style={{
        '--btn-font-size': settings?.btn_font_size + 'px',
        '--btn-padding': settings?.pscfw_fbtn_padding,
        '--btn-bg-clr': settings?.cbc_color,
        '--btn-bg-hvr-clr': settings?.cbh_color,
        '--btn-txt-clr': settings?.btn_text_color,
        '--btn-txt-hvr-clr': settings?.btnh_color,
        padding: 20,
        borderTop: '1px solid #ddd',
        backgroundColor: settings?.atcfb_color,
      }}
    >
      {renderButtons()}
    </div>
  );
};

export default FooterButtons;